<template>
    <NewFileTabTour :tour-name-key="tourNameKey"
               :tour-steps="tourSteps"
               :tour-available="tourAvailable" />
</template>

<script lang="js">
    import { defineComponent } from 'vue';
    import { userGuideService } from '../userGuideService'

    import NewFileTabTour from './NewFileTabTour.vue'

    export default defineComponent({
        props: {
            tourAvailable: {
                type: Boolean,
                default: false,
            }
        },
        components: {
            NewFileTabTour,
        },
        data() {
            return {
                tourNameKey: "translationConfigTour.tourName",
                tourSteps: userGuideService.getConfigurationTour(),
            };
        },
    })
</script>
